import React, { useState, useEffect } from 'react';
import { QrReader } from 'react-qr-reader';
import { getTranslations } from '../../../../../../services/languageUtils';
import CashOutService from '../../../../../../services/Celcoin/dinamicCashOutService';
import AccountManagerService from '../../../../../../services/Celcoin/accountManagerService';
import TedService from '../../../../../../services/Celcoin/tedService';

const TransferTypeQRCode = ({ sendPayment, loadingTranfer, updateValueTransfer, currentBalance }) => {
  const [translations, setTranslations] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [emvData, setEmvData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showScanner, setShowScanner] = useState(false);
  const [colors, setColors] = useState({ primary: '#1c787e', secondary: '#061B2B' });

  const selectColors = (theme) => {
    const themes = {
      zicredit: {
        primary: '#FFCC00',
        secondary: '#061B2B',
      },
      default: {
        primary: '#1c787e',
        secondary: '#061B2B',
      },
    };
    return themes[theme] || themes.default;
  };

  const handleThemeChange = (theme) => {
    setColors(selectColors(theme));
  };

  const verifyDomain = (domain) => {
    const hostname = window.location.hostname;
    return hostname.includes(domain);
  };

  useEffect(() => {
    const loadTranslations = async () => {
      const trans = await getTranslations(localStorage.getItem('language') || 'pt');
      setTranslations(trans);
    };

    if (verifyDomain('zicredit.com')) {
      handleThemeChange('zicredit');
    } else {
      handleThemeChange('default');
    }

    loadTranslations();
  }, []);

  const formatCurrency = (value) =>
    value?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  const onQrCodeScanned = async (result) => {
    const emv = result?.text || result?.data;
    if (!emv) return;

    setShowScanner(false);
    setLoading(true);

    try {
      const emailUser = sessionStorage.getItem('emailUser');
      const res = await CashOutService.showEmv({ qrcode_payload: emv, email: emailUser });
      setEmvData(res.data);
      setIsModalOpen(true);
    } catch (err) {
      console.error('Erro ao consultar EMV:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleCreatePayment = async () => {
    if (!emvData) return null;

    const valor = emvData?.qr_code?.amount;
    if (valor) {
      updateValueTransfer(valor, emvData?.qr_code?.receiver_document_number, emvData?.qr_code?.receiver_name, emvData?.qr_code?.receiver_key_type, emvData?.qr_code?.receiver_key, emvData?.end_to_end_id, emvData?.qr_code?.conciliation_id);
    }
    
    setIsModalOpen(false);
    sendPayment(2);
  };

  const renderEmvData = () => {
    if (!emvData) return null;
    const data = emvData;

    const valor = data?.qr_code?.amount;

    return (
      <div>
        <h3><b>Tipo:</b> {data?.type}</h3>
        {data?.qr_code?.receiver_name && <p><strong>Recebedor:</strong> {data.qr_code.receiver_name}</p>}
        {data?.qr_code?.receiver_document_number && <p><strong>CPF/CNPJ:</strong> {data.qr_code.receiver_document_number}</p>}
        {data?.qr_code?.receiver_key && <p><strong>Chave Pix:</strong> {data.qr_code.receiver_key}</p>}
        {data?.qr_code?.receiver_account_number && <p><strong>Conta:</strong> {data.qr_code.receiver_account_number}</p>}
        {data?.qr_code?.receiver_branch && <p><strong>Agência:</strong> {data.qr_code.receiver_branch}</p>}
        {data?.qr_code?.ispb && <p><strong>ISPB:</strong> {data.qr_code.ispb}</p>}
        {data?.qr_code?.receiver_account_type && <p><strong>Tipo de Conta:</strong> {data.qr_code.receiver_account_type}</p>}
        {valor && (
          <p><strong>Valor:</strong> {formatCurrency(valor)}</p>
        )}
      </div>
    );
  };

  const modalStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.6)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 999,
    },
    content: {
      backgroundColor: '#fff',
      padding: '2rem',
      borderRadius: '10px',
      maxWidth: '500px',
      width: '90%',
      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
    },
    button: {
      marginTop: '1rem',
      backgroundColor: colors.primary,
      color: 'white',
      padding: '10px 20px',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
    },
    closeButton: {
      marginTop: '1.5rem',
      backgroundColor: '#ccc',
      color: '#000',
      padding: '8px 16px',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
    },
  };

  const Modal = ({ children, onClose }) => (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.content}>
        {children}
        <button onClick={onClose} style={modalStyles.closeButton}>Fechar</button>
      </div>
    </div>
  );

  return (
    <div>
      <div className="mainContent100">
        <p>
          <b>{translations.option_available_for_devices_with_camera}</b><br />
          {translations.laptop_or_webcam}
        </p>
        <div
          onClick={() => setShowScanner(true)}
          style={{
            backgroundColor: colors.primary,
            color: '#fff',
            padding: '10px 20px',
            borderRadius: '5px',
            textAlign: 'center',
            cursor: 'pointer',
            display: 'inline-block',
            marginBottom: '1rem'
          }}
        >
          {translations.position_qr_code_in_front_of_camera}
        </div>

        {showScanner && (
          <div style={{ maxWidth: '400px', margin: '0 auto' }}>
            <QrReader
              constraints={{ facingMode: 'environment' }}
              scanDelay={500}
              onResult={(result, error) => {
                if (!!result) {
                  onQrCodeScanned(result);
                }
                if (!!error) {
                  console.error('QR scan error:', error?.message);
                }
              }}
              style={{ width: '100%' }}
            />
          </div>
        )}
      </div>

      {isModalOpen && (
        <Modal onClose={() => setIsModalOpen(false)}>
          <h2><center><b>Confirmar pagamento</b></center></h2>
          {renderEmvData()}
          <button
            onClick={handleCreatePayment}
            style={{ ...modalStyles.button, marginTop: '10px' }}
          >
            <b>Confirmar Pagamento</b>
          </button>
        </Modal>
      )}

      {successModalOpen && (
        <Modal onClose={() => setSuccessModalOpen(false)}>
          <h2><center><b>Pagamento realizado com sucesso!</b></center></h2>
          <p>Seu pagamento foi processado corretamente.</p>
        </Modal>
      )}
    </div>
  );
};

export default TransferTypeQRCode;
